var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { LeaveSpacesRepository } from './leave-space-service.interface';
import { SpacesModel } from '../model/spaces-model';
let LeaveSpacesServiceImpl = class LeaveSpacesServiceImpl {
    constructor(_spacesModel, _leaveSpacesRepository) {
        this._spacesModel = _spacesModel;
        this._leaveSpacesRepository = _leaveSpacesRepository;
    }
    async leaveSpaces(spaceIds) {
        const data = await this._leaveSpacesRepository.leaveSpaces(spaceIds);
        if (data.length > 0) {
            this._spacesModel.update(spaces => this._leaveSpaces(spaces, data));
        }
        return data;
    }
    _leaveSpaces(spaces, data) {
        const leaveIds = data.map(space => space.spaceId);
        return spaces.filter(space => {
            return !leaveIds.includes(space.spaceId);
        });
    }
};
LeaveSpacesServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesModel)),
    __param(1, inject(LeaveSpacesRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _a : Object, typeof (_b = typeof LeaveSpacesRepository !== "undefined" && LeaveSpacesRepository) === "function" ? _b : Object])
], LeaveSpacesServiceImpl);
export { LeaveSpacesServiceImpl };
